export const GROUPS = [
  { code: "U11", name: "U11 Mixed", rule: "Boys born 2015–2016 · Girls born 2014–2016", boys: [2015, 2016], girls: [2014, 2016] },
  { code: "U13", name: "U13 Boys", rule: "Boys born 2013–2014", boys: [2013, 2014] },
  { code: "U15", name: "U15 Boys", rule: "Boys born 2011–2012", boys: [2011, 2012] },
  { code: "GIRLS", name: "Girls Only", rule: "Girls born 2011–2013", girls: [2011, 2013] },
];

export const allocateGroup = (birthYear, gender, groups = GROUPS) => {
  const key = gender === "female" ? "girls" : "boys";
  return (groups || GROUPS).find((g) => g[key] && birthYear >= g[key][0] && birthYear <= g[key][1]) || null;
};
